import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function Cookies() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-slate-800">
      <Seo
        title="Política de Cookies | Web & Studio"
        description="Política de Cookies da Web & Studio: tipos de cookies, finalidade e gestão de preferências."
        path="/cookies"
      />

      <main className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="mb-10">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-800 font-medium">
            Voltar ao início
          </Link>
        </div>

        <header className="space-y-4 mb-12">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900">
            Política de Cookies
          </h1>
          <p className="text-slate-600">
            Última atualização: 16 de fevereiro de 2026.
          </p>
        </header>

        <section className="space-y-8 leading-relaxed">
          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">1. O que são cookies</h2>
            <p>
              Cookies são pequenos ficheiros guardados no navegador para melhorar a experiência de utilização.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">2. Cookies utilizados neste site</h2>
            <p>
              Atualmente utilizamos apenas cookies estritamente necessários ao funcionamento técnico da aplicação.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">3. Cookies de terceiros</h2>
            <p>
              Poderão existir pedidos para serviços externos quando interage com links de redes sociais ou conteúdos incorporados.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">4. Gestão de cookies</h2>
            <p>
              Pode configurar o navegador para bloquear ou eliminar cookies. Essa ação pode afetar funcionalidades do site.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
